import { combineEpics } from 'redux-observable';

import { _reducer } from './Integrations.reducers';
import _epics from './Integrations.epics';

export const epics = combineEpics(_epics);

export { _reducer };
export * from './Integrations.actions';
